export default __webpack_public_path__ + "static/media/au_fuse.392cbc25.jpg";